<template>
  <div class="window window-del-payment-cashbox" v-show="isVisible">
    <span class="close" title="Закрыть" @click="closeWindow"><img src="../image/cancel.svg"></span>
    <div class="window-title">Удалить операцию</div>
    <div class="form">
      <div class="form-block">
        <p>Вы действительно хотите удалить операцию № <span>{{ operationId }}</span>?</p>
      </div>
      <div class="buttons">
        <button type="button" class="cancel-button"
                @click.stop.prevent="closeWindow">Отмена</button>
        <button type="button" class="del-button"
                @click.stop.prevent="deleteOperation">Удалить операцию</button>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api';

  export default {
    name: 'CashboxDeleteOperation',

    props: ['isVisible', 'operation'],

    computed: {
      operationId() {
        return this.operation ? this.operation.id : null;
      }
    },

    methods: {
      deleteOperation() {
        if (!this.operation || !this.operation.id)
          return;

        api
            .deleteCashboxOperation(this.operation.id)
            .then(() => {
              this.$emit('operation-deleted');
              this.closeWindow();
            })
            .catch(message => {
              alert(message);
            });
      },

      closeWindow () {
        this.$emit('close-window', false)
      }
    }
  }
</script>